<template>
  <div>
    <div class="box news-box">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>水保新闻</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl">
          <div class="left-box-title">
            <img src="../../assets/images/new-icon.png" alt />
            水保新闻
            <img src="../../assets/images/right.png" alt />
          </div>
          <div class="left-box-content">
            <dl>
              <dt>排行</dt>
              <dd
                v-for="(item, index) in topData"
                :key="index"
                @click="handelTurnDetail(item)"
              >
                <span class="dot"></span>
                <span :title="item.title">{{ item.title }}</span>
              </dd>
            </dl>
          </div>
        </div>
        <div class="right-box fr">
          <ul>
            <li
              @click="handelTurnDetail(item)"
              :class="'normal'"
              v-for="(item, index) in tableData"
              :key="index"
            >
              <!-- <dl v-if="item.stick == '1' || item.homePageShow == '1'">
                <dt>
                  <span class="title" :title="item.title">{{
                    item.title
                  }}</span>
                  <span class="m-top" v-if="item.stick == '1'">置顶</span>
                  <span class="m-top" v-if="item.homePageShow == '1'"
                    >首页</span
                  >
                </dt>
                <dd>
                  <div
                    class="left fl"
                    v-if="item.stick == '1' && item.homePageShow == '1'"
                    style="width: 320px; height: 180px; overflow: hidden"
                  >
                    <img
                      :src="publicPath + item.thumbnail"
                      alt
                      style="width: 100%; height: auto"
                    />
                  </div>
                  <div
                    class="left fl"
                    v-if="item.stick == '1' && item.homePageShow != '1'"
                    style="width: 320px; height: 180px; overflow: hidden"
                  >
                    <img
                      :src="publicPath + item.thumbnail"
                      alt
                      style="width: 100%; height: auto"
                    />
                  </div>
                  <div
                    class="left fl"
                    v-if="item.homePageShow == '1' && item.stick != '1'"
                    style="width: 320px; height: 180px; overflow: hidden"
                  >
                    <img
                      :src="publicPath + item.homePageImage"
                      alt
                      style="width: 100%; height: auto"
                    />
                  </div>
                  <div class="right fr">
                    <p class="right-time">
                      时间：{{ item.publishTime | dateFormat }}
                    </p>
                    <div class="m-main" style="margin-left: 0">
                      <p>{{ item.textContent | getSimpleText }}</p>
                      <a
                        href="javascript:void(0);"
                        @click="handelTurnDetail(item)"
                        >查看详情></a
                      >
                    </div>
                  </div>
                </dd>
                <dd class="clear"></dd>
              </dl> -->

              <!-- <div v-if="item.stick != '1' && item.homePageShow != '1'"> -->
              <div>
                <span class="fl" :title="item.title">{{ item.title }}</span>
                <span class="m-top-new" v-if="item.stick == '1'">置顶</span>
                <span class="fr">{{ item.publishTime | dateFormat }}</span>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.current"
              :page-sizes="[5, 10, 50, 100, 500]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { getNewsPage, getNewListNewsTop } from "../../api/index";
export default {
  name: "",
  data() {
    return {
      publicPath: window.publicPath,
      query: {
        current: 1,
        size: 10,
        title: "",
      },
      fullHeight: document.documentElement.clientHeight,
      page: {
        total: 0,
      },
      tableData: [],
      topData: [],
    };
  },
  created() {
    this.getData();
    this.getDataTop();
  },
  filters: {
    getSimpleText: function (html) {
      if (!html) {
        return "";
      }
      html = html.replace(/(\n)/g, "");
      html = html.replace(/(\t)/g, "");
      html = html.replace(/(\r)/g, "");
      html = html.replace(/<\/?[^>]*>/g, "");
      html = html.replace(/\s*/g, "");
      html = html.replace(/&nbsp;/g, "");
      html = html.replace(/&ldquo;/g, '"');
      html = html.replace(/&rdquo;/g, '"');
      return html;
    },
    //将时间戳过滤为正常日期格式
    dateFormat: function (data) {
      if (!data) {
        return;
      }
      var date = new Date(data.replace(/-/g, "/")).Format("yyyy-MM-dd");
      return date;
    },
  },
  methods: {
    getDataTop() {
      getNewListNewsTop({}).then((res) => {
        this.topData = res.data;
      });
    },
    getData() {
      getNewsPage(this.query).then((res) => {
        this.tableData = res.data.records;
        this.page.total = res.data.total || 0;
      });
    },
    handleSizeChange(val) {
      this.$set(this.query, "size", val);
      this.getData();
    },
    handleCurrentChange(val) {
      this.$set(this.query, "current", val);
      this.getData();
    },
    handelTurnDetail(row) {
      this.$router.push({
        path: "/newDetail/" + row.id,
      });
    },
  },
};
</script>

<style lang="" >
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue